import {createSelector} from "@reduxjs/toolkit";
import userSelectors from "@legacy/helpers/users/selectors";

const companiesSelector = createSelector(
    state => state.companySwitcher.filteredCompanies,
    filteredCompanies => filteredCompanies
);

const filterTextSelector = createSelector(
    state => state.companySwitcher.filterText,
    filterText => filterText
);

const recentCompaniesSelector = createSelector(
    state => state.companySwitcher.recentCompanies,
    recentCompanies => recentCompanies
);

const selectedCompanySelector = createSelector(
    state => state.companySwitcher.selectedCompany,
    selectedCompany => selectedCompany
);

const showReloadCompaniesSelector = createSelector(
    state => state.companySwitcher.showReloadCompanies,
    reloadCompanies => reloadCompanies
)

const showReloadRecentsSelector = createSelector(
    state => state.companySwitcher.showReloadRecents,
    reloadRecents => reloadRecents
)

const showReloadSelector = createSelector(
    showReloadCompaniesSelector,
    showReloadRecentsSelector,
    (reloadCompanies, reloadRecents) => (reloadCompanies === true || reloadRecents === true)
);

const isReloadSelector = createSelector(
    state => state.companySwitcher.isReload,
    isReload => isReload
)

const visibilitySelector = createSelector(
    userSelectors.isVST,
    isVST => isVST
);

const companySwitcherSelectors = {
    companies: companiesSelector,
    filterText: filterTextSelector,
    recentCompanies: recentCompaniesSelector,
    selectedCompany: selectedCompanySelector,
    showReloadCompanies: showReloadCompaniesSelector,
    showReloadRecents: showReloadRecentsSelector,
    showReload: showReloadSelector,
    isReload: isReloadSelector,
    isVisible: visibilitySelector
};

export default companySwitcherSelectors;